import Spinner, { SpinnerContentProps } from "./ui/spinner";

const CenteredSpinner = ({ ...props }: SpinnerContentProps) => (
    <div className="flex h-full w-full items-center justify-center">
        <Spinner {...props} />
    </div>
);

export default CenteredSpinner;
